import { render, staticRenderFns } from "./UsersManagerItem.vue?vue&type=template&id=1d96e494&"
import script from "./UsersManagerItem.vue?vue&type=script&lang=js&"
export * from "./UsersManagerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports